import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import FooterActions from "./AssignBuildingFooter";
import "./AssignBuilding.scss";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import HeaderBreadCrumb from "./AssignBuildingHeader";
import { setIsConsentChecked } from "src/redux/slices/assignBuildingSlice";
import { Checkbox } from "primereact/checkbox";
import AssignBuildingTitle from "./AssignBuildingTitle";
const Consent = (params: any) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["common", "assignBuilding"]);

  const contractDetails = useSelector(
    (state: any) => state.assignBuilding.contractInfo
  );
  const isConsentChecked = useSelector(
    (state: any) => state.assignBuilding.isConsentChecked
  );

  const handleChange = (e: any): void => {
    dispatch(setIsConsentChecked(e.target.checked));
  };

  const nextClicked = () => {
    console.log("next Clicked");
    console.log("consent");
    console.log(contractDetails);
    //saveAssignedBuilding();
    return true;
  };

  // function saveAssignedBuilding() {
  //   dispatch(save() as any).then(() => {
  //     toast.success(t("Data Saved Successfully"));
  //   });
  // }

  useEffect(() => {
    dispatch(setIsConsentChecked(false));
  }, []);

  return (
    <>
    <AssignBuildingTitle />
    <HeaderBreadCrumb isEditMode={false}></HeaderBreadCrumb>

    <div className="registration-form building-details-form">
      
      <h1 className="text-center m-auto">{t("consentInfo")}</h1>
      <div className="building-details-form__content mb-5">
        <div className="d-flex justify-content-center align-items-start consent-box">
          <Checkbox
            checked={isConsentChecked}
            onChange={handleChange}
          ></Checkbox>
          <span className="mx-2">{t("consentConfirmation")}</span>
        </div>
      </div>
      <FooterActions
        current={"consent"}
        previous={"consent"}
        nextPage={"payment"}
        nextLabel={t("submitPayment")}
        onNextClick={nextClicked}
      ></FooterActions>
    </div>
    </>
  );
};

export default Consent;
